import React from "react";
import type {
	MembershipsUiPermissions,
	Organization,
} from "@/types/Organization";
import type { OrganizationMembershipDto } from "@/types/OrganizationMembership";

export interface OrganizationContextType {
	isValidOrganizationContext: boolean;
	organization: Organization | null | undefined;
	membership: OrganizationMembershipDto | null | undefined;
	defaultLanguage: string;
	isOrganizationAdmin: boolean;
	aiFeaturesEnabled: boolean;
	canAccessFollowUps: boolean;
	uiPermissions: MembershipsUiPermissions;
}
export const OrganizationContext = React.createContext<OrganizationContextType>(
	{
		isValidOrganizationContext: false,
		organization: null,
		membership: null,
		defaultLanguage: "en",
		isOrganizationAdmin: false,
		aiFeaturesEnabled: true,
		canAccessFollowUps: false,
		uiPermissions: {
			sharedReports: [],
			reports: [],
			memberships: [],
			labels: [],
			sharedContent: [],
			attributes: [],
			deliveryPlans: [],
			surveys: [],
		},
	},
);

export interface ValidOrganizationContextType {
	isValidOrganizationContext: true;
	organization: Organization;
	membership: OrganizationMembershipDto;
	defaultLanguage: string;
	isOrganizationAdmin: boolean;
	aiFeaturesEnabled: boolean;
	canAccessFollowUps: boolean;
	uiPermissions: MembershipsUiPermissions;
}

export function useOrganization() {
	const ctx = React.useContext(OrganizationContext);
	if (!ctx.isValidOrganizationContext) {
		throw new Error(
			"useOrganization must be used within a valid OrganizationContext",
		);
	}
	return ctx as ValidOrganizationContextType;
}
